import CircularProgress from "@mui/material/CircularProgress";
import { RagStatus } from "contexts/AthleteMonitoringStatusesContext/AthleteMonitoringStatusesContext.types";
import PopoverWrapper from "components/PopoverWrapper";
import { useLoadingContext } from "hooks";
import { memo, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import MeasureHelpers from "features/Charting/helpers/MeasureHelpers";
import RagStatusIndicator from "components/RagStatusIndicator";
import RagStatusSummaryCard from "components/RagStatusSummaryCard";
import EventHelpers from "helpers/EventHelpers/EventHelpers";
import { useTranslation } from "react-i18next";

interface MonitoringIndicatorProps extends RagStatus {
  athleteId: string;
  hasValues: boolean;
}

function MonitoringIndicator(props: MonitoringIndicatorProps) {
  const { athleteId, hasValues, ...restRagStatusProps } = props;
  const { t } = useTranslation();
  const loadingContext = useLoadingContext();
  const navigate = useNavigate();

  const chartUrl = MeasureHelpers.getAthleteProfileChartUrl(props.athleteId, {
    metadataId: props.metadataId,
  });

  const handleIndicatorClick = useCallback(
    (event: React.MouseEvent) => {
      event.preventDefault();
      navigate(chartUrl);
    },
    [chartUrl, navigate]
  );

  return (
    <>
      {Boolean(!props?.values?.length && loadingContext[0]) && <CircularProgress size={20} color="secondary" />}
      {props.values && (
        <PopoverWrapper id={`rag-popover-${props.athleteId}-${props.metadataId}`}>
          {({ anchorProps, Popover }) => (
            <div onFocus={EventHelpers.stopPropagation}>
              <IconButton
                {...anchorProps}
                disabled={!hasValues}
                onClick={handleIndicatorClick}
                aria-label={t("global.view_more_information_label")}
              >
                <RagStatusIndicator values={props.values} />
              </IconButton>
              {hasValues && (
                <Popover>
                  <RagStatusSummaryCard {...restRagStatusProps} />
                </Popover>
              )}
            </div>
          )}
        </PopoverWrapper>
      )}
    </>
  );
}

export default memo(MonitoringIndicator);
